/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BigCommerceHealthcheckItem } from "./BigCommerceHealthcheckItem";
import {
  BigCommerceHealthcheckItemFromJSON,
  BigCommerceHealthcheckItemFromJSONTyped,
  BigCommerceHealthcheckItemToJSON,
  BigCommerceHealthcheckItemToJSONTyped,
} from "./BigCommerceHealthcheckItem";

/**
 *
 * @export
 * @interface BigCommerceHealthcheckResult
 */
export interface BigCommerceHealthcheckResult {
  /**
   *
   * @type {string}
   * @memberof BigCommerceHealthcheckResult
   */
  storeHash?: string | null;
  /**
   *
   * @type {string}
   * @memberof BigCommerceHealthcheckResult
   */
  linkState: string;
  /**
   *
   * @type {boolean}
   * @memberof BigCommerceHealthcheckResult
   */
  ok: boolean;
  /**
   *
   * @type {Array<BigCommerceHealthcheckItem>}
   * @memberof BigCommerceHealthcheckResult
   */
  items: Array<BigCommerceHealthcheckItem>;
}

/**
 * Check if a given object implements the BigCommerceHealthcheckResult interface.
 */
export function instanceOfBigCommerceHealthcheckResult(
  value: object,
): value is BigCommerceHealthcheckResult {
  if (!("linkState" in value) || value["linkState"] === undefined) return false;
  if (!("ok" in value) || value["ok"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function BigCommerceHealthcheckResultFromJSON(
  json: any,
): BigCommerceHealthcheckResult {
  return BigCommerceHealthcheckResultFromJSONTyped(json, false);
}

export function BigCommerceHealthcheckResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommerceHealthcheckResult {
  if (json == null) {
    return json;
  }
  return {
    storeHash: json["storeHash"] == null ? undefined : json["storeHash"],
    linkState: json["linkState"],
    ok: json["ok"],
    items: (json["items"] as Array<any>).map(
      BigCommerceHealthcheckItemFromJSON,
    ),
  };
}

export function BigCommerceHealthcheckResultToJSON(
  json: any,
): BigCommerceHealthcheckResult {
  return BigCommerceHealthcheckResultToJSONTyped(json, false);
}

export function BigCommerceHealthcheckResultToJSONTyped(
  value?: BigCommerceHealthcheckResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    storeHash: value["storeHash"],
    linkState: value["linkState"],
    ok: value["ok"],
    items: (value["items"] as Array<any>).map(BigCommerceHealthcheckItemToJSON),
  };
}
